import { WeatherAndLocationData } from "../../app/PublicPages/core/models";
import { StoreAction } from "../../utils/actions";

interface WeatherState {
  weatherData: WeatherAndLocationData | null;
  isWeatherDataLoaded: boolean;
}

interface WeatherAction {
  type: string;
  payload: {
    data: WeatherAndLocationData;
  } | null;
}

const initialState: WeatherState = {
  weatherData: null,
  isWeatherDataLoaded: false,
};

export default function weatherReducer(
  state: WeatherState = initialState,
  action: WeatherAction,
): WeatherState {
  switch (action.type) {
    case StoreAction.FETCH_WEATHER_DATA:
      return {
        ...state,
        weatherData: action.payload?.data as WeatherAndLocationData,
        isWeatherDataLoaded: true,
      };
    default:
      return state;
  }
}
